import { render } from "./TheAdminHomeTitle.vue?vue&type=template&id=24d778e2"
import script from "./TheAdminHomeTitle.vue?vue&type=script&lang=js"
export * from "./TheAdminHomeTitle.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__